<template>
  <v-container
    id="operation-parameters"
    fluid
    tag="section"
  >
    <base-material-card
      inline
      icon="mdi-cog-outline"
      :title="`${$t('sidebar.groups').toUpperCase()}`"
      class="px-5 py-3"
    >
      <v-col
        cols="12"
        sm="12"
      >
        <!-- Ajouter un paramètre (Seulement pour le rôle 'admin')-->
        <v-col
          class="text-right ml-4"
          cols="12"
        >
          <v-btn
            color="success"
            @click="addItem"
          >
            {{ $t('Add') }}
            <v-icon
              right
              dark
            >
              mdi-plus-circle-outline
            </v-icon>
          </v-btn>
        </v-col>

        <v-data-table
          :headers="tableHeaders"
          :items="table"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          :search="search"
          item-key="id"
          @page-count="pageCount = $event"
        >
          <!-- Search-->
          <template #top>
            <v-text-field
              v-model="search"
              :label="$t('search')"
              class="mx-4"
            />
          </template>

          <!-- Action-->
          <template
            slot="item.action"
            slot-scope="props"
          >
            <!-- Edit-->
            <v-btn
              fab
              dark
              x-small
              color="success"
              :title="$t('Edit')"
              @click="editItem(props.item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <!--  Delete (Seulement pour le rôle 'admin')-->
            <v-btn
              v-if="isRoleAdmin"
              class="ml-2"
              fab
              dark
              x-small
              color="red"
              :title="$t('Delete')"
              @click="deleteItem(props.item.id)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
          />
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              cols="12"
              sm="4"
            >
              <!-- <v-text-field
                :value="itemsPerPage"
                :label="$t('table.Items_per_page')"
                type="number"
                min="-1"
                max="15"
                @input="itemsPerPage = parseInt($event, 10)"
              /> -->
              <v-select
                v-model="itemsPerPage"
                :items="itemsPage"
                :label="$t('table.Items_per_page')"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </base-material-card>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="submitForm">
        <validation-observer
          ref="obs"
          v-slot="{ handleSubmit }"
        >
          <form>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ submitType === 'edit' ? $t('Edit') : $t('Add') }} {{ $t('The_group').toLowerCase() }}</v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <!-- Descrition-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                Description
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  name="Description"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.description"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Code-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                Code
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  name="Code"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.code"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Commentaire-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('Comment') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('Comment')"
                  rules="required"
                >
                  <v-textarea
                    v-model="submitForm.commentaires"
                    solo
                    append-icon="mdi-comment"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <div class="pa-3 text-center">
              <!--  Bouton annuler-->
              <v-btn
                color="error"
                @click="dialog = false"
              >
                {{ $t('Cancel') }}
              </v-btn>
              <!--  Bouton submit-->
              <v-btn
                color="success"
                class="ml-3"
                @click="handleSubmit(submit)"
              >
                {{ $t('Validate') }}
              </v-btn>
            </div>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  // Services
  import GroupesService from '@/services/01Cell/GroupesService'
  // Mixins
  import { roles } from '@/mixins/roles'
  // Other
  import {
    ValidationObserver,
    ValidationProvider,
  } from 'vee-validate'
  import Swal from 'sweetalert2'

  export default {
    name: 'OperationParameters',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    mixins: [roles],
    data () {
      return {
        search: '',
        submitForm: {},
        submitType: null,
        table: [],
        tableHeaders: [
          { text: 'Code', value: 'code', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Description', value: 'description', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('Comment'), value: 'commentaires', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Action', value: 'action', sortable: false, align: 'end', class: 'text-h4 primary--text', width: 150 },
        ],
        page: 1,
        pageCount: 0,
        itemsPerPage: 50,
        itemsPage: [5, 10, 25, 50, 100],
        dialog: false,
      }
    },

    computed: {
    },

    async mounted () {
      this.getGroups()
    },

    methods: {
      async getGroups () {
        // Start Spinner
        this.$loading.show()
        try {
          this.table = await GroupesService.list()
          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      async editItem (item) {
        // Start Spinner
        this.$loading.show()
        try {
          // Edit
          this.submitType = 'edit'
          // Paramètre
          this.submitForm = await GroupesService.view(item.id)
          // Show dialog
          this.dialog = true
          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      addItem () {
        // Ajout
        this.submitType = 'add'
        // Reset du submit
        this.submitForm = {}
        // Show dialog
        this.dialog = true
      },
      deleteItem (id) {
        // SweetAlert
        Swal.fire({
          icon: 'warning',
          title: this.$i18n.t('Are_you_sure'),
          text: `${this.$i18n.t('Delete_group')} ?`,
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: this.$i18n.t('Yes_delete_it'),
          cancelButtonText: this.$i18n.t('Cancel'),
        }).then(async (result) => {
          if (result.value) {
            // Start Loader
            this.$loading.show()
            try {
              await GroupesService.remove(id)

              this.getGroups()
            } catch (err) {
              // Stop Spinner
              this.$loading.hide()
            }
          }
        })
      },
      async submit () {
        // Hide dialog
        this.dialog = false

        // Start Spinner
        this.$loading.show()
        try {
          if (this.submitType === 'edit') {
            await GroupesService.update(this.submitForm, this.submitForm.id)
          } else {
            await GroupesService.save(this.submitForm)
          }

          this.getGroups()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
    },
  }
</script>
